import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MessagingEnvironmentService } from '../../../../core/services/messaging-environment.service';
import { ITag } from '../../interfaces/ITag';

@Injectable()
export class TagsApiService {
  constructor(private httpClient: HttpClient, private env: MessagingEnvironmentService) {}

  getTags(): Observable<ITag[]> {
    return this.httpClient.get<ITag[]>(
      `${this.env.env.apiUrl + this.env.env.messagingApiPath}/tag/generic?entityType=MESSAGEABLE_ENTITY`
    );
  }
}
